import React, { Fragment, useRef, useState } from 'react';
import cls from 'classnames';
import { Container } from '@ott/grid';

import ChevronDownIcon from '@ott/icon-chevron-down';

import styles from './ExtendableList.scss';

const ExtendableList = ({ children }) => {
  const [listHeight, setListHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);

  const handleListItemToggle = () => {
    const scrollHeight = containerRef.current?.scrollHeight ?? 0;
    const listHeight = isOpen ? 0 : scrollHeight;
    setIsOpen(!isOpen);
    setListHeight(listHeight);
  };

  const [trigger, listContainer] = children;

  return (
    <Fragment>
      <div className={styles.trigger} onClick={handleListItemToggle}>
        <Container className={styles.triggerContainer}>
          {trigger}
          <ChevronDownIcon
            className={cls(styles.chevronIcon, isOpen && styles.chevronIconInverse)}
          />
        </Container>
      </div>
      <div ref={containerRef} style={{ height: listHeight }} className={styles.extendableContainer}>
        {listContainer}
      </div>
    </Fragment>
  );
};

export default React.memo(ExtendableList);
